import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=19a58b9a&scoped=true&lang=pug"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"
import style0 from "./Book.vue?vue&type=style&index=0&id=19a58b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a58b9a",
  null
  
)

export default component.exports